import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-12 px-4 md:px-8 bg-navy-800" data-id="element-180">
      <div className="max-w-3xl mx-auto" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-navy-700 to-navy-900 border-2 border-gold/30 rounded-3xl p-8 md:p-12 text-center relative box-glow" data-id="element-182">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-navy-900 rounded-full p-4 border-2 border-gold/30" data-id="element-183">
            <ShieldCheckIcon className="w-12 h-12 text-gold" data-id="element-184" />
          </div>

          <h3 className="mt-6" className="text-3xl font-bold text-white mb-8" data-id="element-185">
            Garantía Incondicional de 7 Días
          </h3>

          <div className="space-y-6 text-lg" data-id="element-186">
            <p className="text-gold font-bold text-xl md:text-2xl leading-relaxed" data-id="element-187">
              Si en los próximos 7 días sientes que este sistema no entrega lo
              prometido, te devolvemos el 100% de tu dinero.
            </p>

            <p className="text-gray-300" data-id="element-188">
              Sin preguntas. Sin condiciones. Sin burocracia.
            </p>

            <p className="text-white font-bold text-xl uppercase tracking-wide pt-4 border-t border-gray-700/50" data-id="element-189">
              Todo el riesgo es nuestro. Todo el beneficio es tuyo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}